import React, { useEffect, useState } from "react";

import CPPlayers from "./cpPlayers";
import HowToPlaychpt from "./HowToPlaychpt";
import { compose } from "redux";
import Socket from "../../socket/socket";
import { withRouter } from "react-router-dom";
import * as socketAction from "../../redux/sockets/action";
import { connect } from "react-redux";

const ChartyPartyLobby = ({ how_to_play, usersChanged, toggleHowToPlay, ...props }) => {
  const [round, setRound] = useState(4);
  let roomData = props.gameReducer.roomObj;

  let sfwForMapp = roomData.lobby_parameters.safe_for_work;

  const [sfw, setSfw] = useState(false);
  // useEffect(() => {
  //   console.log(sfw, "7MWEV7MWEV");
  //   let data = {
  //     action: "update-lobby-options",
  //     roomId: roomData.id,
  //     safe_for_work: sfw,
  //   };
  //   Socket.sendMessage(data);
  // }, [sfw]);

  return (
    <>
      {how_to_play ? (
        <HowToPlaychpt toggleHowToPlay={toggleHowToPlay} />
      ) : (
        <CPPlayers usersChanged={usersChanged} sfw={sfw} setSfw={setSfw} round={round} setRound={setRound} />
      )}
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

const mapDispatchToProps = (dispatch) => {
  return {
    toggleHowToPlay: (data) => dispatch(socketAction.toggleHowToPlay(data)),
  };
};
export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ChartyPartyLobby);
